"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ar_viewer_1 = __importDefault(require("./ar-viewer"));
class SceneViewer extends ar_viewer_1.default {
    constructor() {
        super();
        this.araction = null;
        this.isVertical = false;
        this.titleHTML = "<b>" + document.title;
        this.isVertical = false;
    }
    get nodeType() {
        return "Scene Viewer";
    }
    get device() {
        return "android";
    }
    start() {
        if (!this.modelUrl) {
            throw new Error("SceneViewer.start() - model url not set, use SceneViewer.modelUrl");
        }
        const araction = this.araction;
        let composedLink = encodeURIComponent(location.href);
        if (araction) {
            const link = new URL(location.href);
            link.searchParams.set("araction", araction);
            composedLink = encodeURIComponent(link.href);
        }
        if (!composedLink) {
            throw new Error("SceneViewer.start() - failed to create composition link, check parameters");
        }
        const linkOverride = encodeURIComponent(location.href + '#no-ar-fallback');
        let intent = 'intent://arvr.google.com/scene-viewer/1.1';
        intent += '?file=' + this.modelUrl;
        intent += '&mode=ar_preferred';
        intent += '&link=' + composedLink;
        intent += '&title=<b>' + this.titleHTML;
        if (this.isVertical) {
            intent += '&enable_vertical_placement=true';
        }
        intent += ' #Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;';
        intent += 'S.browser_fallback_url=' + linkOverride + ';end;';
        const anchor = document.createElement("a");
        anchor.setAttribute("href", intent);
        anchor.click();
    }
}
exports.default = SceneViewer;
